/* Verhuisd uit sections/single-product.liquid: stond als inline script in het
   document (parse vóór de eerste paint). Liquid-waarden komen uit window.FLORAFY_PDP,
   gezet door de sectie vlak vóór deze scripts. */
var cfg = window.FLORAFY_PDP || {};
window.florafyUpdateSaveBadges = function (totalCents, compareCents) {
    var saving = compareCents > totalCents ? compareCents - totalCents : 0;
    document.querySelectorAll('.js-save-badge').forEach(function (el) {
      if (saving > 0) {
        var amount = (saving / 100).toFixed(2).replace('.', ',').replace(/,00$/, '');
        var template = el.getAttribute('data-save-template') || '';
        el.textContent = template.replace('[amount]', amount);
        el.style.display = '';
      } else {
        el.style.display = 'none';
      }
    });
    document.querySelectorAll('.js-price-breakdown-total, .js-sticky-configuration-price, .sticky-mobile-atc__price').forEach(function (el) {
      el.classList.toggle('is-sale', saving > 0);
    });
  };

  document.addEventListener('DOMContentLoaded', function () {
    // Native anchor jumps are broken by the overflow-x clip/hidden on html/body,
    // so review links scroll programmatically instead.
    function scrollToReviews() {
      var target = document.getElementById('product-reviews');
      if (target) target.scrollIntoView({ block: 'start' });
      return !!target;
    }
    document.querySelectorAll('a[href="#product-reviews"]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        if (scrollToReviews()) e.preventDefault();
      });
    });
    if (location.hash === '#product-reviews') {
      setTimeout(scrollToReviews, 300);
    }

    function formatStickyConfigurationPrice(cents) {
      return (cents / 100).toFixed(2).replace('.', ',');
    }

    function splitStickyConfigurationPrice(cents) {
      const parts = formatStickyConfigurationPrice(cents).split(',');
      return {
        euros: parts[0],
        cents: parts[1] || '00'
      };
    }

    function updateStickyConfigurationPrice(event) {
      const total = parseInt(event.detail?.total || 0, 10);
      const compare = parseInt(event.detail?.compare || 0, 10);
      if (!total) return;

      document.querySelectorAll('.js-sticky-configuration-price').forEach(function(el) {
        el.textContent = window.florafyFormatMoney
          ? window.florafyFormatMoney(total)
          : formatStickyConfigurationPrice(total);
      });

      document.querySelectorAll('.js-sticky-configuration-compare').forEach(function(el) {
        if (compare && compare > total) {
          el.textContent = formatStickyConfigurationPrice(compare);
          el.style.display = '';
        } else {
          el.style.display = 'none';
        }
      });

      const mobileEuros = document.querySelector('.js-sticky-price-euros');
      const mobileCents = document.querySelector('.sticky-mobile-atc__cents');
      if (mobileEuros && mobileCents) {
        const parts = splitStickyConfigurationPrice(total);
        mobileEuros.textContent = parts.euros;
        mobileCents.textContent = ',' + parts.cents;
      }

      // De doorgestreepte prijs in de mobiele sticky balk hoort bij de hele
      // configuratie (plant + pot), niet bij de kale plant; anders staat er
      // "van 219,95 voor 314,90".
      const mobileCompare = document.querySelector('.sticky-mobile-atc__compare');
      if (mobileCompare) {
        if (compare && compare > total) {
          mobileCompare.textContent = window.florafyFormatMoney
            ? window.florafyFormatMoney(compare)
            : '€' + formatStickyConfigurationPrice(compare);
          mobileCompare.style.display = '';
        } else {
          mobileCompare.style.display = 'none';
        }
      }

      window.florafyUpdateSaveBadges(total, compare);
    }

    window.addEventListener('florafy:configuration-price-update', updateStickyConfigurationPrice);

    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get('variant');

    const configDiv = document.querySelector('.js-plant-configuration');

    if (variantId && configDiv) {
      configDiv.dataset.productVariantId = variantId;

      // eventueel ook prijs aanpassen:
      const variant = Shopify.product.variants.find(v => v.id == variantId);
      if (variant) {
        configDiv.dataset.price = variant.price;
      }
    } else if (configDiv) {
      // fallback naar eerste variant
      configDiv.dataset.productVariantId = configDiv.dataset.productId;
    }
  });

  /**
   * ========================================
   * VARIANT PRICE UPDATE FOR CLEAN DISPLAY
   * ========================================
   * Updates price display when variant selection changes
   */

  // Listen for variant changes (existing theme JS should trigger this)
  document.addEventListener('DOMContentLoaded', function() {
    const variantSelects = document.querySelectorAll('[name="id"], .product-hero__variants a');
    const priceData = document.querySelector('.js-variant-price-data');

    if (!priceData) return; // Single variant product, no need to update

    // Update price display
    function updatePriceDisplay(variantId) {
      const variantSpan = priceData.querySelector(`[data-variant-id="${variantId}"]`);
      if (!variantSpan) return;

      const newPrice = variantSpan.dataset.price;
      const newCompare = variantSpan.dataset.compare;

      if (window.florafyUpdateSaveBadges) {
        window.florafyUpdateSaveBadges(parseInt(newPrice, 10) || 0, parseInt(newCompare, 10) || 0);
      }
      const mainPriceEl = document.querySelector('.js-product-price-display');
      if (mainPriceEl) {
        mainPriceEl.classList.toggle('is-sale', (parseInt(newCompare, 10) || 0) > (parseInt(newPrice, 10) || 0));
      }

      // Update main product price display
      const priceDisplay = document.querySelector('.price-display-clean');
      if (priceDisplay) {
        // Update data attributes (the snippet's JS will handle the rest)
        priceDisplay.dataset.priceIncl = newPrice;
        priceDisplay.dataset.priceExcl = Math.floor(newPrice / 1.21);

        if (newCompare && parseInt(newCompare) > 0) {
          priceDisplay.dataset.compareIncl = newCompare;
          priceDisplay.dataset.compareExcl = Math.floor(newCompare / 1.21);
        } else {
          priceDisplay.dataset.compareIncl = '0';
          priceDisplay.dataset.compareExcl = '0';
        }

        // Trigger price refresh
        const event = new CustomEvent('priceUpdate', { detail: { price: newPrice, compare: newCompare } });
        priceDisplay.dispatchEvent(event);

        // Also trigger the snippet's internal update by simulating preference change
        const savedPref = localStorage.getItem('florafy_price_preference') || 'incl';
        if (window.togglePriceView) {
          window.togglePriceView(savedPref);
        }
      }

      // Update sticky CTA prices (respects user preference)
      updateStickyCTAPrice(newPrice, newCompare);
      if (window.updateFillingAddonPriceNote) {
        window.updateFillingAddonPriceNote(variantId);
      }
    }

    /**
     * Update sticky CTA price based on user's preference
     */
    const currencySymbol = cfg.currencySymbol;
    function updateStickyCTAPrice(priceIncl, compareIncl) {
      const formatPrice = (cents) => window.florafyFormatMoney(cents);

      // Get user preference
      const savedPref = localStorage.getItem('florafy_price_preference') || 'incl';
      const isExcl = savedPref === 'excl';

      // Calculate prices
      const priceExcl = Math.floor(priceIncl / 1.21);
      const compareExcl = compareIncl ? Math.floor(compareIncl / 1.21) : 0;

      // Use preference to determine which price to show
      const displayPrice = isExcl ? priceExcl : priceIncl;
      const displayCompare = isExcl ? compareExcl : compareIncl;

      // Update all sticky CTA price elements
      const stickyPrices = document.querySelectorAll('.js-sticky-cta-price');
      stickyPrices.forEach(el => {
        el.textContent = formatPrice(displayPrice);
      });

      // Update compare prices if they exist
      const stickyCompares = document.querySelectorAll('.js-sticky-cta-compare');
      stickyCompares.forEach(el => {
        if (displayCompare && displayCompare > displayPrice) {
          el.textContent = formatPrice(displayCompare);
          el.style.display = '';
        } else {
          el.style.display = 'none';
        }
      });
    }

    // Listen for variant selection via dropdown
    variantSelects.forEach(select => {
      if (select.tagName === 'SELECT') {
        select.addEventListener('change', function() {
          updatePriceDisplay(this.value);
        });
      } else {
        // Link-based variant selector
        select.addEventListener('click', function(e) {
          const variantId = this.dataset.variantId || this.getAttribute('data-variant-id');
          if (variantId) {
            updatePriceDisplay(variantId);
          }
        });
      }
    });

    // Listen for price preference changes to update sticky CTA
    const priceToggleInputs = document.querySelectorAll('.js-price-pref');
    priceToggleInputs.forEach(input => {
      input.addEventListener('change', function() {
        if (this.checked) {
          // Get current prices from main display
          const mainPriceDisplay = document.querySelector('.price-display-clean');
          if (mainPriceDisplay) {
            const currentPrice = parseInt(mainPriceDisplay.dataset.priceIncl) || 0;
            const currentCompare = parseInt(mainPriceDisplay.dataset.compareIncl) || 0;
            updateStickyCTAPrice(currentPrice, currentCompare);
          }
        }
      });
    });

    // Initial sticky CTA price sync
    const initialPriceDisplay = document.querySelector('.price-display-clean');
    if (initialPriceDisplay) {
      const initialPrice = parseInt(initialPriceDisplay.dataset.priceIncl) || 0;
      const initialCompare = parseInt(initialPriceDisplay.dataset.compareIncl) || 0;
      updateStickyCTAPrice(initialPrice, initialCompare);
    }
  });

  /**
   * ========================================
   * VARIANT IMAGE FILTER
   * ========================================
   * Rebuilds the product slider with only images matching
   * the selected variant option (e.g. color name).
   */
  function filterSliderByVariant(optionValue) {
    var dataEl = document.getElementById('all-product-images-data');
    if (!dataEl) return;

    var allImagesRaw = JSON.parse(dataEl.textContent);
    var entries = allImagesRaw.split(',').filter(function(e) { return e.trim() !== ''; });

    // Filter entries: keep untagged images + images matching selected option
    var filtered = entries.filter(function(entry) {
      var parts = entry.split('|||');
      var opt = parts[1] ? parts[1].trim() : '';
      return !opt || opt === optionValue;
    });

    // Extract just the URLs (without option tags)
    var urls = filtered.map(function(entry) { return entry.split('|||')[0]; });

    // Rebuild main slider
    var mainSlider = document.querySelector('.js-product-hero-main-slider');
    if (!mainSlider) return;
    var $main = $(mainSlider);
    if ($main.hasClass('slick-initialized')) $main.slick('unslick');

    // Build slide HTML
    var slidesHtml = urls.map(function(url, i) {
      var s400 = url.replace('_1920x', '_400x').replace('1920x.', '400x.');
      var s480 = url.replace('_1920x', '_480x').replace('1920x.', '480x.');
      var s560 = url.replace('_1920x', '_560x').replace('1920x.', '560x.');
      var s600 = url.replace('_1920x', '_600x').replace('1920x.', '600x.');
      var s800 = url.replace('_1920x', '_800x').replace('1920x.', '800x.');
      var s1200 = url.replace('_1920x', '_1200x').replace('1920x.', '1200x.');
      var s1600 = url.replace('_1920x', '_1600x').replace('1920x.', '1600x.');
      return '<div class="product-hero-main-slider__slide ratio ratio-1x1 rounded-3 overflow-hidden h-auto">' +
        '<img src="' + s800 + '" srcset="' + s400 + ' 400w, ' + s480 + ' 480w, ' + s560 + ' 560w, ' + s600 + ' 600w, ' + s800 + ' 800w, ' + s1200 + ' 1200w, ' + s1600 + ' 1600w, ' + url + ' 1920w" ' +
        'sizes="(max-width: 991px) 66vw, (max-width: 1399px) 40vw, 600px" ' +
        'class="product-hero-main__image" width="800" height="800" loading="' + (i === 0 ? 'eager' : 'lazy') + '">' +
        '<a href="' + url + '" class="stretched-link" data-fancybox="product-gallery"></a></div>';
    }).join('');

    mainSlider.innerHTML = slidesHtml;
    if (urls.length > 1) {
      $main.slick({ slidesToShow: 1, slidesToScroll: 1, arrows: false, fade: true, rows: 0, infinite: false });
    }

    // Rebuild thumbnail nav
    var navSlider = document.querySelector('.js-product-hero-main-nav');
    if (navSlider) {
      var thumbsHtml = urls.map(function(url) {
        var t150 = url.replace('_1920x', '_150x').replace('1920x.', '150x.');
        var t100 = url.replace('_1920x', '_100x').replace('1920x.', '100x.');
        var t200 = url.replace('_1920x', '_200x').replace('1920x.', '200x.');
        return '<div class="product-hero-main-nav__slide ratio rounded-1 overflow-hidden ratio-1x1 h-auto">' +
          '<img class="img-abs-center" src="' + t150 + '" srcset="' + t100 + ' 100w, ' + t150 + ' 150w, ' + t200 + ' 200w" ' +
          'sizes="(max-width: 991px) 80px, 100px" width="150" height="150" loading="lazy"></div>';
      }).join('');
      navSlider.innerHTML = thumbsHtml;
      if (window.florafyThumbnailNav) window.florafyThumbnailNav.bind();
    }
  }

  /**
   * ========================================
   * NATIVE VARIANT SELECTOR (for pots)
   * ========================================
   * Handles native Shopify variant selection via dropdown
   */
  function initNativeVariantSelector() {
    const nativeSelectors = document.querySelectorAll('.js-native-option-selector');
    if (nativeSelectors.length === 0) return;

    const sectionEl = document.getElementById('combined-listing-section');
    const productVariants = sectionEl ? JSON.parse(sectionEl.dataset.productVariants || '[]') : cfg.variants;
    const availabilityData = sectionEl ? sectionEl.querySelector('.js-variant-availability-data') : null;
    const variantAvailability = availabilityData ? JSON.parse(availabilityData.textContent || '{}') : {};

    // Format price in euros (cents to formatted string)
    function formatPrice(cents) {
      const euros = (cents / 100).toFixed(2).replace('.', ',');
      return euros;
    }

    function optionVariantIds(option) {
      return (option.dataset.variantIds || '').split(',').filter(Boolean);
    }

    function selectedVariantId() {
      let candidateIds = null;
      nativeSelectors.forEach(select => {
        const selectedOption = select.options[select.selectedIndex];
        const ids = selectedOption ? optionVariantIds(selectedOption) : [];
        candidateIds = candidateIds === null
          ? ids
          : candidateIds.filter(id => ids.includes(id));
      });
      return candidateIds && candidateIds.length === 1 ? candidateIds[0] : null;
    }

    function optionHasAvailableVariant(option, selectorIndex) {
      let candidateIds = optionVariantIds(option);
      nativeSelectors.forEach((select, index) => {
        if (index === selectorIndex) return;
        const selectedOption = select.options[select.selectedIndex];
        const selectedIds = selectedOption ? optionVariantIds(selectedOption) : [];
        candidateIds = candidateIds.filter(id => selectedIds.includes(id));
      });
      return candidateIds.some(id => variantAvailability[id] === true);
    }

    function updateOptionAvailability() {
      nativeSelectors.forEach((select, selectorIndex) => {
        Array.from(select.options).forEach(option => {
          option.disabled = !optionHasAvailableVariant(option, selectorIndex);
        });
      });
    }

    function updatePurchaseButtons(variant) {
      const isAvailable = variant && variantAvailability[String(variant.id)] === true;
      document.querySelectorAll('.js-add-to-cart, .js-sticky-atc-btn').forEach(btn => {
        if (variant) btn.dataset.variantId = variant.id;
        btn.disabled = !isAvailable;
        btn.setAttribute('aria-disabled', String(!isAvailable));
        btn.classList.toggle('btn-disabled', !isAvailable);
      });
    }

    // Update variant ID input and price
    function updateVariant() {
      const variantId = selectedVariantId();
      const variant = productVariants.find(item => String(item.id) === variantId);
      updatePurchaseButtons(variant);
      updateOptionAvailability();

      if (variant) {
        console.log('Native variant selector: switching to variant', variant.id, variant.title);

        // Update hidden variant ID inputs
        const variantInputs = document.querySelectorAll('#variant-id, .js-variant-id');
        variantInputs.forEach(input => {
          input.value = variant.id;
        });

        // Update URL without reload
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);

        // Update price display - direct DOM update
        const priceFormatted = formatPrice(variant.price);
        const priceParts = priceFormatted.split(',');

        // Update main price (euros and cents with comma prefix)
        const eurosEl = document.querySelector('.js-product-price-euros');
        const centsEl = document.querySelector('.js-product-price-cents');
        if (eurosEl) eurosEl.textContent = priceParts[0];
        if (centsEl) centsEl.textContent = ',' + priceParts[1];

        // Also update price-display-clean data attributes for the toggle functionality
        const priceDisplay = document.querySelector('.price-display-clean, [data-price-incl]');
        if (priceDisplay) {
          priceDisplay.dataset.priceIncl = variant.price;
          priceDisplay.dataset.priceExcl = Math.floor(variant.price / 1.21);
          if (variant.compare_at_price) {
            priceDisplay.dataset.compareIncl = variant.compare_at_price;
            priceDisplay.dataset.compareExcl = Math.floor(variant.compare_at_price / 1.21);
          } else {
            priceDisplay.dataset.compareIncl = '0';
            priceDisplay.dataset.compareExcl = '0';
          }
          // Trigger price refresh if toggle function exists
          const savedPref = localStorage.getItem('florafy_price_preference') || 'incl';
          if (window.togglePriceView) {
            window.togglePriceView(savedPref);
          }
        }

        // Update sticky CTA price
        const stickyPrice = document.querySelector('.js-product-price');
        if (stickyPrice) {
          stickyPrice.textContent = priceFormatted;
        }

        // Update pot diameter from variant title (format: "D14 x H13")
        const diameterMatch = variant.title.match(/D\s*(\d+)/i);
        if (diameterMatch) {
          const diameter = parseInt(diameterMatch[1]);
          const diameterEl = document.querySelector('.js-value-opening .fw-semibold');
          if (diameterEl) {
            diameterEl.textContent = diameter + ' cm';
          }
        }

        // Update pot height from variant title (format: "D14 x H13")
        const heightMatch = variant.title.match(/H\s*(\d+)/i);
        if (heightMatch) {
          const height = parseInt(heightMatch[1]);
          const heightEl = document.querySelector('.js-value-height .fw-semibold');
          if (heightEl) {
            heightEl.textContent = height + ' cm';
          }
        }

        // Filter image slider to show only images matching selected variant option
        filterSliderByVariant(variant.title);

        // Update simple total unit price when variant changes
        var simpleTotal = document.querySelector('.js-simple-total');
        if (simpleTotal) {
          simpleTotal.dataset.unitPrice = variant.price;
          simpleTotal.dataset.comparePrice = (variant.compare_at_price || 0);
          if (typeof updateSimpleTotal === 'function') updateSimpleTotal();
        }

        if (window.updateFillingAddonPriceNote) {
          window.updateFillingAddonPriceNote(variant.id);
        }

        // Trigger custom event for other scripts
        window.dispatchEvent(new CustomEvent('nativeVariantChange', {
          detail: { variant: variant }
        }));
      }
    }

    // Pre-select variant from URL on page load
    function initFromUrl() {
      const urlParams = new URLSearchParams(window.location.search);
      const variantId = urlParams.get('variant');

      if (variantId) {
        const variant = productVariants.find(v => v.id == variantId);
        if (variant) {
          // Set the dropdowns to match the variant's options
          variant.options.forEach((optionValue, index) => {
            const selector = nativeSelectors[index];
            if (selector) {
              selector.value = optionValue;
            }
          });
        }
      }
    }

    // Initialize from URL
    initFromUrl();
    updateVariant();

    // Listen for changes
    nativeSelectors.forEach(select => {
      if (select.dataset.variantBound) return; // idempotency guard
      select.dataset.variantBound = '1';
      select.addEventListener('change', updateVariant);
    });
  }
  window._florafyInitNativeVariantSelector = initNativeVariantSelector;
  document.addEventListener('DOMContentLoaded', initNativeVariantSelector);
  // Guard listener-registration itself — if this section block is rendered multiple times
  // on a page (Shopify section rendering API), avoid stacking listeners.
  if (!window._florafyNVSListenerBound) {
    window._florafyNVSListenerBound = true;
    window.addEventListener('combined-listing:swapped', function () {
      if (typeof window._florafyInitNativeVariantSelector === 'function') {
        window._florafyInitNativeVariantSelector();
      }
    });
  }

  /**
   * ========================================
   * QUICKVIEW MODAL ENHANCEMENT
   * ========================================
   * Adds diameter and height specs from variant title
   */
  document.addEventListener('DOMContentLoaded', function() {
    // Parse variant title to extract diameter and height
    // Format: "D20 x H20" or "D14 x H13" or "D20xH20"
    function parseDimensions(variantTitle) {
      if (!variantTitle) return { diameter: null, height: null };

      const dimensions = { diameter: null, height: null };

      // Match D followed by number (diameter)
      const diameterMatch = variantTitle.match(/D\s*(\d+)/i);
      if (diameterMatch) {
        dimensions.diameter = parseInt(diameterMatch[1]);
      }

      // Match H followed by number (height)
      const heightMatch = variantTitle.match(/H\s*(\d+)/i);
      if (heightMatch) {
        dimensions.height = parseInt(heightMatch[1]);
      }

      return dimensions;
    }

    // Update modal with dimensions
    function updateQuickviewDimensions(variantTitle) {
      const dimensions = parseDimensions(variantTitle);

      const diameterEl = document.querySelector('.js-quickview__diameter');
      const diameterValueEl = document.querySelector('.js-quickview__diameter-value');
      const heightEl = document.querySelector('.js-quickview__height');
      const heightValueEl = document.querySelector('.js-quickview__height-value');

      // Update diameter
      if (diameterEl && diameterValueEl) {
        if (dimensions.diameter) {
          diameterValueEl.textContent = dimensions.diameter + ' cm';
          diameterEl.style.cssText = 'display: flex !important;';
        } else {
          diameterEl.style.cssText = 'display: none !important;';
        }
      }

      // Update height
      if (heightEl && heightValueEl) {
        if (dimensions.height) {
          heightValueEl.textContent = dimensions.height + ' cm';
          heightEl.style.cssText = 'display: flex !important;';
        } else {
          heightEl.style.cssText = 'display: none !important;';
        }
      }
    }

    // Listen for clicks on quickview toggle (magnifying glass)
    document.addEventListener('click', function(e) {
      const toggle = e.target.closest('.js-quickview-toggle');
      if (toggle) {
        const variantTitle = toggle.dataset.variantTitle;
        // Small delay to ensure modal content is populated by app.js first
        setTimeout(function() {
          updateQuickviewDimensions(variantTitle);
        }, 10);
      }
    });

    // Also listen for pot label clicks (which also show quickview data)
    document.addEventListener('click', function(e) {
      const label = e.target.closest('.js-select-pot');
      if (label) {
        const container = label.closest('.related-pots');
        if (container) {
          const toggle = container.querySelector('.js-quickview-toggle');
          if (toggle) {
            const variantTitle = toggle.dataset.variantTitle;
            setTimeout(function() {
              updateQuickviewDimensions(variantTitle);
            }, 10);
          }
        }
      }
    });
	  });
